export default "__VITE_ASSET__BR7Y1tph__"